import isEmpty from 'lodash/isEmpty'

export default function collection(existing, ...args) {
  if (!isEmpty(args)) {
    return [...existing || [], args]
  } else {
    return existing 
  }
}



// WEBPACK FOOTER //
// ./src/config/features/collection.js